import { http } from '@Techedge/digitalportal-shared'
import { AttachmentProps } from '../models/attachment'
import {
    Chapter,
    FolderType,
    ResourceType,
    SortingType,
    SurveyProps,
    Visibility,
} from '../models/new-resource'

export class ResourcesService {
    static BASE_URL: string = process.env.REACT_APP_BASE_URL_BE
    static RESOURCES_BASE_URL: string = ResourcesService.BASE_URL + `/resourcesapi`
    static ATTACHMENTS_URL: string = ResourcesService.BASE_URL + `/attachmentsapi`
    static FROALA_UPLOAD_URL: string = `${ResourcesService.ATTACHMENTS_URL}/froala/upload`

    static headersObj = {
        headers: {
            'Accept-Language': '',
        },
        timeout: 180000,
    }

    static GetResources = (filters: {
        folderId?: string
        folderType?: FolderType
        sortingType?: SortingType
        withStores?: string
    }) => {
        if (filters.folderId === null) {
            delete filters.folderId
        }
        if (filters.folderType === null) {
            delete filters.folderType
        }
        if (filters.sortingType === null) {
            delete filters.sortingType
        }
        let queryString = new URLSearchParams(filters).toString()
        return http.get<any>(
            ResourcesService.RESOURCES_BASE_URL + `/folders?${queryString}`,
            ResourcesService.headersObj
        )
    }

    static GetFolder = (filters: { folderId?: string }) => {
        let queryString = new URLSearchParams(filters).toString()
        return http.get<any>(
            ResourcesService.RESOURCES_BASE_URL + `/folder?${queryString}`,
            ResourcesService.headersObj
        )
    }

    static GetDocument = (documentId: string) => {
        return http.get<any>(
            ResourcesService.RESOURCES_BASE_URL + `/documents?documentId=${documentId}`,
            ResourcesService.headersObj
        )
    }

    static CreateFolder = (body: {
        title: string
        folderType: string
        visibility: Visibility[]
        storeList: string[]
        parentFolderId?: string
    }) => {
        return http.post<any>(
            ResourcesService.RESOURCES_BASE_URL + `/folders`,
            body,
            ResourcesService.headersObj
        )
    }

    static EditFolder = (body: {
        title: string
        visibility: Visibility[]
        storeList: string[]
        folderId: string
        parentFolderId?: string
    }) => {
        return http.put<any>(
            ResourcesService.RESOURCES_BASE_URL + `/folders`,
            body,
            ResourcesService.headersObj
        )
    }

    static CreateDocument = (body: {
        title?: string
        resourceType: string
        department: string
        attachments?: AttachmentProps[]
        attachmentData?: { _id: string; title: string }[]
        parentFolderId?: string
        recipients?: string[]
        survey?: SurveyProps
        abstract?: any
        chapters?: Chapter[]
        requiredConfirmReading?: boolean
        enableCommentsAndReactions?: boolean
    }) => {
        return http.post<any>(
            ResourcesService.RESOURCES_BASE_URL + `/${body.attachmentData ? 'multifile' : 'documents'}`,
            body,
            ResourcesService.headersObj
        )
    }

    static EditDocument = (
        _id: string,
        body: {
            title: string
            department?: string
            attachments?: AttachmentProps[]
            parentFolderId?: string
            recipients?: string[]
            survey?: SurveyProps
            abstract?: any
            chapters?: Chapter[]
            resetViewsCount?: boolean
            requiredConfirmReading?: boolean
            enableCommentsAndReactions?: boolean
        }
    ) => {
        return http.put<any>(
            ResourcesService.RESOURCES_BASE_URL + `/documents?documentId=${_id}`,
            body,
            ResourcesService.headersObj
        )
    }

    static PublishArticle = (documentId: string) => {
        return http.put<any>(
            ResourcesService.RESOURCES_BASE_URL + `/documents/publish`,
            {
                documentId: documentId,
            },
            ResourcesService.headersObj
        )
    }

    static CreateQuickLink = (body: {
        title: string
        url: string
        description: string
        visibility: Visibility[]
        storeList: string[]
    }) => {
        return http.post<any>(
            ResourcesService.RESOURCES_BASE_URL + `/quicklinks`,
            body,
            ResourcesService.headersObj
        )
    }

    static EditQuickLink = (
        body: {
            title: string
            url: string
            description: string
            visibility: Visibility[]
            storeList: string[]
        },
        quicklinkId: string
    ) => {
        return http.put<any>(
            ResourcesService.RESOURCES_BASE_URL + `/quicklinks?quicklinkId=${quicklinkId}`,
            body,
            ResourcesService.headersObj
        )
    }

    static GetLinks = () => {
        return http.get<any>(
            ResourcesService.RESOURCES_BASE_URL + `/quicklinks`,
            ResourcesService.headersObj
        )
    }

    static GetLinksID = (linkId: string) => {
        return http.get<any>(
            ResourcesService.RESOURCES_BASE_URL + `/quicklinks?quicklinkId=${linkId}`,
            ResourcesService.headersObj
        )
    }
}
